(() => {
  const root = document.getElementById('mp-privacy');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const tab = root.querySelector('.mp-privacy-tab');
  const panel = root.querySelector('#mp-privacy-panel');
  const customize = root.querySelector('.mp-privacy-customize');
  const options = root.querySelector('#mp-privacy-options');
  const status = root.querySelector('.mp-privacy-status');
  const actions = [...root.querySelectorAll('[data-consent]')];
  const fields = ['preferences','analytics','marketing'];
  panel.hidden = true;
  panel.style.display = 'none';
  tab.setAttribute('aria-expanded','false');
  window.addEventListener('pageshow', () => {
    panel.hidden = true;
    panel.style.display = 'none';
    tab.setAttribute('aria-expanded','false');
  });
  let api;
  let busy = false;
  let lastFocus = null;
  const setDisabled = value => actions.forEach(button => { button.disabled = value; });
  const sync = () => {
    if (!api) return;
    const saved = api.currentVisitorConsent();
    fields.forEach(name => { root.querySelector('[name="'+name+'"]').checked = saved[name] === 'yes'; });
  };
  const close = () => {
    panel.hidden = true;
    panel.style.display = 'none';
    tab.setAttribute('aria-expanded','false');
    if (lastFocus && lastFocus.isConnected) lastFocus.focus();
  };
  tab.addEventListener('click', () => {
    if (!panel.hidden) { close(); return; }
    lastFocus = document.activeElement;
    sync();
    panel.hidden = false;
    panel.style.display = 'block';
    tab.setAttribute('aria-expanded','true');
    panel.querySelector('.mp-privacy-close').focus();
  });
  root.querySelector('.mp-privacy-close').addEventListener('click',close);
  root.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !panel.hidden) { event.preventDefault(); close(); }
  });
  customize.addEventListener('click', () => {
    options.hidden = !options.hidden;
    customize.setAttribute('aria-expanded',String(!options.hidden));
  });
  actions.forEach(button => button.addEventListener('click', () => {
    if (!api || busy) return;
    busy = true;
    setDisabled(true);
    status.textContent = root.dataset.loading;
    const choice = button.dataset.consent;
    const consent = {};
    fields.forEach(name => {
      consent[name] = choice === 'save' ? root.querySelector('[name="'+name+'"]').checked : choice === 'accept';
    });
    let finished = false;
    const timer = setTimeout(() => {
      if (finished) return;
      finished = true;
      busy = false;
      setDisabled(false);
      status.textContent = root.dataset.error;
    },10000);
    try {
      api.setTrackingConsent(consent, () => {
        if (finished) return;
        finished = true;
        clearTimeout(timer);
        busy = false;
        const saved = api.currentVisitorConsent();
        const success = fields.every(name => saved[name] === (consent[name] ? 'yes' : 'no'));
        setDisabled(false);
        status.textContent = success ? root.dataset.saved : root.dataset.error;
        if (success) close();
      });
    } catch (error) {
      finished = true;
      clearTimeout(timer);
      busy = false;
      setDisabled(false);
      status.textContent = root.dataset.error;
    }
  }));
  const ready = () => {
    api = window.Shopify && window.Shopify.customerPrivacy;
    if (!api || typeof api.setTrackingConsent !== 'function' || typeof api.currentVisitorConsent !== 'function') {
      status.textContent = root.dataset.error;
      return;
    }
    sync();
    setDisabled(false);
    status.textContent = '';
  };
  if (window.Shopify && window.Shopify.customerPrivacy) {
    ready();
  } else if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}],error => {
      if (error) { status.textContent = root.dataset.error; return; }
      ready();
    });
  } else {
    status.textContent = root.dataset.error;
  }
})();